import apiClient from './apiClient';
import { GET_USER_ACCESS_LIST_URL } from './apiUrl';

const getUserAccessListApi = () => {
  return apiClient.get(GET_USER_ACCESS_LIST_URL);
};

export default getUserAccessListApi;
